import React, { useState, useEffect } from 'react';

import ScoringCriteriaTableDisplayRow from './ScoringCriteriaTableDisplayRow';
import ScoringCriteriaTableEditRow from './ScoringCriteriaTableEditRow';

export default function ScoringCriteriaIndexTable(props) {
    const [criteriaList, setCriteriaList] = useState([]);
    const [request, setRequest] = useState(false);
    const [editedCriteria, setEditedCriteria] = useState(null);

    useEffect(() => {
        fetchCriteria();
    }, []);

    const fetchCriteria = () => {
        setRequest(true);
        axios
            .untranslated()
            .get(props.fetchUrl)
            .then((res) => {
                const { scoringCriteria } = res.data;
                setCriteriaList([...scoringCriteria]);
                resetEdited();
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const setEdited = (item) => {
        if (props.canEdit) {
            setEditedCriteria(item);
        }
    };

    const resetEdited = () => {
        setEditedCriteria(null);
    };

    const prepareUpdateUrl = (item) => {
        return props.updateUrl.replace('CRITERIA_ID', item.id);
    };

    return (
        <div className="table__card">
            <div id="sorting-criteria-table" className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-48">{$t('Marks')}</th>
                            <th>{$t('Description')}</th>
                            <th className="tw-w-20">{$t('Score')}</th>
                            <th className="tw-w-40">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {criteriaList.map((item) => {
                            if (editedCriteria && parseInt(editedCriteria.id) === parseInt(item.id)) {
                                return (
                                    <ScoringCriteriaTableEditRow
                                        key={item.id}
                                        criteria={editedCriteria}
                                        updateUrl={prepareUpdateUrl(item)}
                                        fetchCriteria={fetchCriteria}
                                        cancelAction={resetEdited}
                                        canEdit={props.canEdit}
                                    ></ScoringCriteriaTableEditRow>
                                );
                            } else {
                                return (
                                    <ScoringCriteriaTableDisplayRow
                                        key={item.id}
                                        editAction={() => {
                                            setEdited(item);
                                        }}
                                        criteria={item}
                                        canEdit={props.canEdit}
                                    ></ScoringCriteriaTableDisplayRow>
                                );
                            }
                        })}
                    </tbody>
                </table>
            </div>
            <div id="criteria-update-toast" className="toast" style={{ position: 'absolute', top: 0, right: 0 }} data-delay={2000}>
                <div className="toast-header">
                    <strong className="mr-auto text-capitalize">{$t('Scoring Criteria')}</strong>
                    <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">{$t('Scoring criteria updated successfully')}</div>
            </div>
            <div id="criteria-update-failed-toast" className="toast" style={{ position: 'absolute', top: 0, right: 0 }} data-delay={2000}>
                <div className="toast-header">
                    <strong className="mr-auto">{$t('Error')}</strong>
                    <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">{$t('Scoring criteria update failed')}</div>
            </div>
        </div>
    );
}
